import { ChangeDetectorRef, Component, EventEmitter, Input, Output, SimpleChanges, ViewChild } from '@angular/core';
import { DocumentoAccredito, Evento, Persona, Subappalto } from '../../../../shared/interface';
import { Table, TableRowExpandEvent } from 'primeng/table';
import { Subject } from 'rxjs';
import { ConfirmPopup } from 'primeng/confirmpopup';
import { ConfirmationService } from 'primeng/api';
import { ApiService } from '../../../../services/api.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-subappalti-accrediti-backoffice',
  templateUrl: './subappalti-accrediti-backoffice.component.html',
  styleUrls: ['./subappalti-accrediti-backoffice.component.css']
})
export class SubappaltiAccreditiBackofficeComponent {

  constructor(
    private apiService: ApiService,
    private confirmationService: ConfirmationService,
    private route: ActivatedRoute
  ) {}

  @ViewChild('delete') delete!: ConfirmPopup;

  @Input() visible: boolean = false;
  @Input() subappalti: Subappalto[] = [];
  @Input() evento?: Evento;

  persona?: Persona;
  subappalto?: Subappalto;

  add: boolean = false;
  edit: boolean = false
  
  loading: boolean = false;
  private notaDraft = new Map<number, string>();  

  ngOnChanges(changes: SimpleChanges): void {
    this.subappalti = changes['subappalti']?.currentValue || this.subappalti;
    this.evento = changes['evento']?.currentValue || this.evento;
  }

  posDovuto(_s: Subappalto): boolean {
    const e = this.evento as any;
    if (e?.obbl_pos_subappalti != null) return !!e.obbl_pos_subappalti;
    return !!e?.obbligatorieta;
  }

  onGlobalFilter(table: Table, event: Event) {
    table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
  }

  onOpenDocumento(file: string) {
    this.apiService.openProtectedFile(file);
  }

  onOpenDelete(event: Event, subappalto: Subappalto) {
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: `Sei sicuro di voler eliminare il subappalto?`,
      reject: () => this.confirmationService.close(),
      accept: () => {        
        this.apiService.deleteSubappalto(subappalto.id).subscribe({
          next: (data) => {
            this.apiService.setSubappaltiEvento(this.evento?.id!);
            this.apiService.setDocumentiEvento(this.evento?.id!);
          },
          error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
          complete: () => {
            this.confirmationService.close()
            this.apiService.message("success", "Eliminazione", "Il subappalto è stato eliminato con successo!")
          }
        })
      },
    });
  }

  onDelete() {
    this.delete.accept();
  }

  onClose() {
    this.delete.reject();
  }  

  onOpenEdit(subappalto: Subappalto) {
    this.subappalto = subappalto;
    this.edit = true;    
  }

  onCloseEdit(close: boolean) {
    this.edit = false;
    this.subappalto = undefined;
  }

  onDownloadDocumenti() {    

    this.loading = true;

    let documenti: any[] = []
    this.subappalti.map(subappalto => {
      documenti.push({file: subappalto.visura_camerale, nome: subappalto.visura_camerale})
      documenti.push({file: subappalto.pos, nome: subappalto.pos})
      documenti.push({file: subappalto.autocertificazione, nome: subappalto.autocertificazione})
    });

    // Recupero la ricevuta
    this.apiService.getZipDocumenti(documenti).subscribe({
      next: (data) => {
        const url = window.URL.createObjectURL(data);
        const a = document.createElement('a');
        a.target = '_blank'
        a.href = url;
        a.download = `documenti.zip`;
        a.click();
        this.loading = false;
        setTimeout(() => window.URL.revokeObjectURL(url), 1000);       
      },
      error: (err) => {
        this.loading = false;
        this.apiService.message('error', 'Errore', err.message)        
      },
    });
  }

  onStato(stato: string, subappalto: Subappalto) {
    const next = subappalto.stato === stato ? 'ok' : stato;
    this.loading = true;
    this.apiService.updateValidazioneSubappalto(subappalto.id, { stato: next }).subscribe({
      next: () => {
        subappalto.stato = next;
        if (this.evento?.id) {
          this.apiService.setDocumentiEvento(this.evento.id);
          this.apiService.documentoStatoChanged.next(this.evento.id);
        }
      },
      error: (err) => {
        this.loading = false;
        this.apiService.message('error', 'Errore', err?.error?.message?.message || err.message);
      },
      complete: () => { this.loading = false; },
    });
  }

  onNotaDraft(subappalto: Subappalto, value: string) {
    this.notaDraft.set(subappalto.id, value);
  }

  onNotaBlur(subappalto: Subappalto) {
    const note = this.notaDraft.has(subappalto.id) ? this.notaDraft.get(subappalto.id)! : (subappalto.note || '');
    if (note === (subappalto.note || '')) return;
    this.apiService.updateValidazioneSubappalto(subappalto.id, { note: note || null }).subscribe({
      next: () => {
        subappalto.note = note;
        this.apiService.message('success', 'Note', 'Nota aggiornata');
      },
      error: (err) => this.apiService.message('error', 'Errore', err?.error?.message?.message || err.message),
    });
  }

}
